export function sanityDownloadUrl(fileUrl, originalFilename) {
  if (!fileUrl) return ''

  const downloadUrl = new URL(fileUrl)
  downloadUrl.searchParams.set('dl', originalFilename || '')

  return downloadUrl.toString()
}
